import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useFormik } from 'formik';
import { Button, Col, Form, Row } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { Link, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import * as Yup from 'yup';
import datagain_home_page_hero_img from '../../../assets/images/datagain-home-page-hero-img.png';
import logo from '../../../assets/images/logo.svg';
import { COUNTRY_LIST_API_URL, REGISTER_API_URL, STATE_API_URL } from '../../../constants/ApiUrlConstants';
import { BASE_URL } from '../../../constants/Config';
import { LOGIN_ROUTE, SUCCESS_ROUTE, TERMS_AND_CONDITONS_ROUTE } from '../../../constants/RouteNameConstants';
import {
  CITY_MAX_VALID,
  CITY_REQURIED,
  COFIRM_PASSWORD_REQURIED,
  COUNTRY_REQURIED,
  EMAIL_ID_MAX_VALID,
  EMAIL_ID_REQURIED,
  EMAIL_ID_VALID,
  FIRST_NAME_ALPHABET,
  FIRST_NAME_MAX_VALID,
  FIRST_NAME_REQURIED,
  LAST_NAME_ALPHABET,
  LAST_NAME_MAX_VALID,
  LAST_NAME_REQURIED,
  PASSWORD_INCLUDE_VALID,
  PAYPAL_EMAIL_ID_MAX_VALID,
  PAYPAL_EMAIL_ID_REQURIED,
  PAYPAL_EMAIL_ID_VALID,
  PHONE_NUMBER_MAX_REQURIED,
  PHONE_NUMBER_REQURIED,
  PHONE_NUMBER_VALID,
  SPECILIZATION_REQURIED,
  SPECILIZATION_VALID,
  STATE_REQURIED,
  TERMS_AND_CONDITIONS_VALID,
  ZIP_CODE_REQURIED,
  ZIP_CODE_VALID,
} from '../../../constants/ValidationMessageConstants';

const Register = () => {
  const navigate = useNavigate();
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);

  useEffect(() => {
    const getCountries = async () => {
      try {
        const response = await axios.get(`${BASE_URL}${COUNTRY_LIST_API_URL}`, {
          headers: { accept: '*/*' },
        });
        if (response.data.value) {
          const countryList = JSON.parse(response.data.value);
          setCountries(countryList);
        }
        if (response?.data?.errorMessage !== '' && !response.data?.success) {
          toast.error(response?.data?.errorMessage);
        }
      } catch (error) {
        toast.error('Failed to fetch countries!');
      }
    };

    getCountries();
  }, []);

  const fetchStates = async (countryId) => {
    try {
      const response = await axios.get(`${BASE_URL}${STATE_API_URL}?countryId=${countryId}`, {
        headers: { accept: '*/*' },
      });
      if (response.data.value) {
        const stateList = JSON.parse(response.data.value);
        setStates(stateList);
      }
      if (response?.data?.errorMessage !== '' && !response.data?.success) {
        toast.error(response?.data?.errorMessage);
      }
    } catch (error) {
      toast.error('Failed to fetch states!');
    }
  };

  const formik = useFormik({
    initialValues: {
      Email: '',
      PaypalEmail: '',
      Zip: '',
      FirstName: '',
      LastName: '',
      PhoneNumber: '',
      City: '',
      Specilization: '',
      Password: '',
      ConfirmPassword: '',
      Country: '',
      State: '',
      TermsAndConditions: false,
    },
    validationSchema: Yup.object({
      Email: Yup.string()
        .required(EMAIL_ID_REQURIED)
        .email(EMAIL_ID_VALID)
        .max(255, EMAIL_ID_MAX_VALID)
        .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, EMAIL_ID_VALID),
      PaypalEmail: Yup.string()
        .required(PAYPAL_EMAIL_ID_REQURIED)
        .email(PAYPAL_EMAIL_ID_VALID)
        .max(255, PAYPAL_EMAIL_ID_MAX_VALID)
        .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, PAYPAL_EMAIL_ID_VALID),
      Zip: Yup.string().matches(/^\d+$/, ZIP_CODE_VALID).required(ZIP_CODE_REQURIED),
      FirstName: Yup.string()
        .matches(/^[A-Za-z\s]*$/, FIRST_NAME_ALPHABET)
        .required(FIRST_NAME_REQURIED)
        .max(255, FIRST_NAME_MAX_VALID),
      LastName: Yup.string()
        .matches(/^[A-Za-z\s]*$/, LAST_NAME_ALPHABET)
        .required(LAST_NAME_REQURIED)
        .max(255, LAST_NAME_MAX_VALID),
      PhoneNumber: Yup.string()
        .required(PHONE_NUMBER_REQURIED)
        .matches(/^\d{10}$/, PHONE_NUMBER_MAX_REQURIED)
        .matches(/^[\d\s()-]+$/, PHONE_NUMBER_VALID),
      City: Yup.string().required(CITY_REQURIED).max(255, CITY_MAX_VALID),
      Specilization: Yup.string().required(SPECILIZATION_REQURIED).oneOf(['1', '2', '3'], SPECILIZATION_VALID),
      Password: Yup.string()
        .min(8, PASSWORD_INCLUDE_VALID)
        .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/, PASSWORD_INCLUDE_VALID)
        .required(PASSWORD_INCLUDE_VALID),
      ConfirmPassword: Yup.string()
        .oneOf([Yup.ref('Password'), null], COFIRM_PASSWORD_REQURIED)
        .required(COFIRM_PASSWORD_REQURIED),
      Country: Yup.string().required(COUNTRY_REQURIED),
      State: Yup.string().required(STATE_REQURIED),
      TermsAndConditions: Yup.boolean().oneOf([true], TERMS_AND_CONDITIONS_VALID).required(TERMS_AND_CONDITIONS_VALID),
    }),
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values) => {
      try {
        const formData = new FormData();
        formData.append('firstName', values.FirstName);
        formData.append('lastName', values.LastName);
        formData.append('email', values.Email);
        formData.append('password', values.Password);
        formData.append('country', values.Country);
        formData.append('state', values.State);
        formData.append('city', values.City);
        formData.append('phoneNumber', values.PhoneNumber);
        formData.append('zip', values.Zip);
        formData.append('paypalEmail', values.PaypalEmail);
        formData.append('specialization', values.Specilization);

        const response = await axios.post(`${BASE_URL}${REGISTER_API_URL}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        if (response?.data?.success && response?.data?.resultMessage !== '') {
          navigate(SUCCESS_ROUTE);
          toast.success(response?.data?.resultMessage);
        }
        if (response?.data?.errorMessage !== '' && !response.data?.success) {
          toast.error(response?.data?.errorMessage);
        }
      } catch (error) {
        toast.error('Registration failed!');
      }
    },
  });

  // Convert `countries` data to react-select format
  const countryOptions = [
    { value: '', label: 'Select Country', isDisabled: true },
    ...(countries.map((data) => ({
      value: data.Id,
      label: data.Name,
    })) || []),
  ];

  return (
    <div className="d-flex vh-100 w-100 flex-column overflow-y-auto bg-lighter">
      <div className="d-flex flex-grow-1 align-items-center justify-content-center py-4">
        <div className="login-card shadow-sm register-card">
        
            <div className="form-group">
              <Link to={LOGIN_ROUTE}>
              <img src={logo} alt="logo" className="img-fluid logo-img" />
              </Link>
            </div>
            <div className="">
              <div>
                <div className="form-group mb-4">
                  <h1 className="form-title text-center">Account Setup</h1>
                </div>

                <Form onSubmit={formik.handleSubmit}>
                  <Row>
                    {/* ==== Email ==== */}
                    <Col xs={12}>
                    <label className="form-label fnt-14 fw-normal">Email</label>
                      <Form.Group className="mb-3">
                        <Form.Control
                          id="Email"
                          type="email"
                          {...formik.getFieldProps('Email')}
                          placeholder="Enter email address"
                          autoComplete="off"
                          data-lpignore="true"
                          name="Email"
                        />
                        {formik.touched.Email && formik.errors.Email && (
                          <div className="text-danger">{formik.errors.Email}</div>
                        )}
                      </Form.Group>
                    </Col>

                    {/* ==== First Name ==== */}
                    <Col xs={6}>
                    <label className="form-label fnt-14 fw-normal">First name</label>
                      <Form.Group className="mb-3">
                        <Form.Control
                          id="FirstName"
                          type="text"
                          {...formik.getFieldProps('FirstName')}
                          placeholder="Enter first name"
                          autoComplete="off"
                        />
                        {formik.touched.FirstName && formik.errors.FirstName && (
                          <div className="text-danger">{formik.errors.FirstName}</div>
                        )}
                      </Form.Group>
                    </Col>

                    {/* ==== Last Name ==== */}
                    <Col xs={6}>
                    <label className="form-label fnt-14 fw-normal">Last name</label>
                      <Form.Group className="mb-3">
                        <Form.Control
                          id="LastName"
                          type="text"
                          {...formik.getFieldProps('LastName')}
                          placeholder="Enter last name"
                          autoComplete="off"
                        />
                        {formik.touched.LastName && formik.errors.LastName && (
                          <div className="text-danger">{formik.errors.LastName}</div>
                        )}
                      </Form.Group>
                    </Col>

                    {/* ==== Country ==== */}
                    <Col xs={6}>
                    <label className="form-label fnt-14 fw-normal">Country</label>
                      <Form.Group className="mb-3">
                        <Select
                          id="country-register"
                          options={countryOptions}
                          value={countryOptions.find((opt) => opt.value === formik.values.Country) || null}
                          onChange={(selectedOption) => {
                            formik.setFieldValue('Country', selectedOption.value);
                            fetchStates(selectedOption.value);
                          }}
                          isSearchable
                          placeholder="Select Country"
                          classNamePrefix="custom-select"
                          aria-labelledby="country-register"
                          styles={{
                            control: (base) => ({
                              ...base,
                              height: '53.99px',
                              width: '100%',
                              border: '1px solid #e6e6e6',
                              borderRadius: '6px',
                            }),
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999, // Ensure the dropdown is above the modal
                            }),
                          }}
                          autoComplete="off"
                          menuPortalTarget={document.body} // Render dropdown outside the modal
                        />
                        {formik.touched.Country && formik.errors.Country && (
                          <div className="text-danger">{formik.errors.Country}</div>
                        )}
                      </Form.Group>
                    </Col>

                    {/* ==== State ==== */}
                    <Col xs={6}>
                    <label className="form-label fnt-14 fw-normal">State</label>
                      <Form.Group className="mb-3">
                        <Select
                          id="state-register"
                          options={[
                            { value: '', label: 'Select State', isDisabled: true }, // Default disabled option
                            ...states.map((state) => ({
                              value: state.Id,
                              label: state.Name,
                            })),
                          ]}
                          value={
                            states.find((s) => s.Id === formik.values.State)
                              ? {
                                  value: formik.values.State,
                                  label: states.find((s) => s.Id === formik.values.State)?.Name,
                                }
                              : null
                          }
                          onChange={(selectedOption) => {
                            formik.setFieldValue('State', selectedOption.value);
                          }}
                          isSearchable
                          placeholder="Select State"
                          classNamePrefix="custom-select"
                          aria-labelledby="state-register"
                          styles={{
                            control: (base) => ({
                              ...base,
                              height: '53.99px',
                              width: '100%',
                              border: '1px solid #e6e6e6',
                              borderRadius: '6px',
                            }),
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999, // Ensure the dropdown is above the modal
                            }),
                          }}
                          autoComplete="off"
                          menuPortalTarget={document.body} // Render dropdown outside the modal
                        />
                        {formik.touched.State && formik.errors.State && (
                          <div className="text-danger">{formik.errors.State}</div>
                        )}
                      </Form.Group>
                    </Col>

                    {/* ==== City ==== */}
                    <Col xs={6}>
                    <label className="form-label fnt-14 fw-normal">City</label>
                      <Form.Group className="mb-3">
                        <Form.Control
                          id="City"
                          type="text"
                          {...formik.getFieldProps('City')}
                          placeholder="Enter city"
                          autoComplete="off"
                        />
                        {formik.touched.City && formik.errors.City && (
                          <div className="text-danger">{formik.errors.City}</div>
                        )}
                      </Form.Group>
                    </Col>

                    {/* ==== Specialization ==== */}
                    <Col xs={6}>
                    <label className="form-label fnt-14 fw-normal">Specialization</label>
                      <Form.Group className="mb-3">
                        <Select
                          options={[
                            { value: '', label: 'Select Specialization', isDisabled: true }, // Default disabled option
                            { value: '1', label: 'General' },
                            { value: '2', label: 'Legal' },
                            { value: '3', label: 'Medical' },
                          ]}
                          value={
                            formik.values.Specilization
                              ? {
                                  value: formik.values.Specilization,
                                  label:
                                    formik.values.Specilization === '1'
                                      ? 'General'
                                      : formik.values.Specilization === '2'
                                        ? 'Legal'
                                        : 'Medical',
                                }
                              : null
                          }
                          onChange={(selectedOption) => {
                            formik.setFieldValue('Specilization', selectedOption.value);
                          }}
                          isSearchable
                          placeholder="Select Specialization"
                          classNamePrefix="custom-select-specialization"
                          styles={{
                            control: (base) => ({
                              ...base,
                              height: '53.99px',
                              width: '100%',
                              border: '1px solid #e6e6e6',
                              borderRadius: '6px',
                            }),
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999, // Ensure the dropdown is above the modal
                            }),
                          }}
                          autoComplete="off"
                          menuPortalTarget={document.body} // Render dropdown outside the modal
                        />
                        {formik.touched.Specilization && formik.errors.Specilization && (
                          <div className="text-danger">{formik.errors.Specilization}</div>
                        )}
                      </Form.Group>
                    </Col>

                    {/* ==== ZIP ==== */}
                    <Col xs={6}>
                    <label className="form-label fnt-14 fw-normal">Zip code</label>
                      <Form.Group className="mb-3">
                        <Form.Control
                          id="Zip"
                          type="text"
                          {...formik.getFieldProps('Zip')}
                          placeholder="Enter zip code"
                          autoComplete="off"
                        />
                        {formik.touched.Zip && formik.errors.Zip && (
                          <div className="text-danger">{formik.errors.Zip}</div>
                        )}
                      </Form.Group>
                    </Col>

                    {/* ==== Phone Number ==== */}
                    <Col xs={6}>
                    <label className="form-label fnt-14 fw-normal">Phone Number</label>
                      <Form.Group className="mb-3">
                        <Form.Control
                          id="PhoneNumber"
                          type="text"
                          {...formik.getFieldProps('PhoneNumber')}
                          placeholder="Enter phone number"
                          autoComplete="off"
                        />
                        {formik.touched.PhoneNumber && formik.errors.PhoneNumber && (
                          <div className="text-danger">{formik.errors.PhoneNumber}</div>
                        )}
                      </Form.Group>
                    </Col>

                    {/* ==== Password ==== */}
                    <Col xs={6}>
                    <label className="form-label fnt-14 fw-normal">New Password</label>
                      <Form.Group className="mb-3">
                        <Form.Control
                          id="Password"
                          type="password"
                          {...formik.getFieldProps('Password')}
                          placeholder="Enter password"
                          autoComplete="new-password"
                          data-lpignore="true"
                          name="Password"
                        />
                        {formik.touched.Password && formik.errors.Password && (
                          <div className="text-danger">{formik.errors.Password}</div>
                        )}
                      </Form.Group>
                    </Col>

                    {/* ==== Confirm Password ==== */}
                    <Col xs={6}>
                    <label className="form-label fnt-14 fw-normal">Confirm Password</label>
                      <Form.Group className="mb-3">
                        <Form.Control
                          id="ConfirmPassword"
                          type="password"
                          {...formik.getFieldProps('ConfirmPassword')}
                          placeholder="Enter confirm password"
                          autoComplete="confirm-password"
                          data-lpignore="true"
                          name="ConfirmPassword"
                        />
                        {formik.touched.ConfirmPassword && formik.errors.ConfirmPassword && (
                          <div className="text-danger">{formik.errors.ConfirmPassword}</div>
                        )}
                      </Form.Group>
                    </Col>

                    {/* ==== Paypal Email ==== */}
                    <Col xs={12}>
                    <label className="form-label fnt-14 fw-normal">Paypal email</label>
                      <Form.Group className="mb-3">
                        <Form.Control
                          id="PaypalEmail"
                          type="email"
                          {...formik.getFieldProps('PaypalEmail')}
                          placeholder="Enter paypal email address"
                          autoComplete="nope"
                          data-lpignore="true"
                        />
                        {formik.touched.PaypalEmail && formik.errors.PaypalEmail && (
                          <div className="text-danger">{formik.errors.PaypalEmail}</div>
                        )}
                      </Form.Group>
                    </Col>

                    {/* ==== Terms and Conditions ==== */}
                    <Col xs={12} className="signup-term mb-3 fnt-14">
                      <Form.Check
                        id="terms-conditions"
                        type="checkbox"
                        label={
                          <div style={{ marginLeft: '6px' }}>
                            I agree to Datagain's{' '}
                            <Link to={TERMS_AND_CONDITONS_ROUTE} className="link-color">
                              terms and conditions
                            </Link>
                          </div>
                        }
                        {...formik.getFieldProps('TermsAndConditions')}
                      />
                      <Form.Control.Feedback type="invalid">
                        {formik.touched.TermsAndConditions && formik.errors.TermsAndConditions}
                      </Form.Control.Feedback>
                    </Col>

                    <Button type="submit">Submit</Button>
                  </Row>
                </Form>

                <div className="my-3 text-center fnt-14">
                  Already have an account?{' '}
                  <Link to={LOGIN_ROUTE} className="link-color">
                    Sign in Here
                  </Link>
                </div>
              </div>
            </div>
          
        </div>
      </div>
    </div>
  );
};

export default Register;
